import { DataExportManager } from "@/components/DataExportManager";

export default function DataExport() {
  return <DataExportManager />;
}